import { defineStore } from 'pinia';

export const useModalStore = defineStore('modal', {
  state: () => ({
    isOpen: false,
    title: '',
    message: '',
    icon: '',
    iconType: 'primary',
    confirmText: 'Aceptar',
    cancelText: 'Cancelar',
    type: 'confirm', // confirm, info, danger, success
    resolve: null,
    reject: null
  }),
  actions: {
    confirm({ title, message, icon, iconType, confirmText, cancelText, type }) {
      this.isOpen = true;
      this.title = title || '¿Estás seguro?';
      this.message = message || '';
      this.icon = icon || 'mdi:help-circle';
      this.iconType = iconType || 'primary';
      this.confirmText = confirmText || 'Aceptar';
      this.cancelText = cancelText || 'Cancelar';
      this.type = type || 'confirm';
      
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    accept() {
      if (this.resolve) this.resolve(true);
      this.close();
    },
    cancel() {
      if (this.resolve) this.resolve(false);
      this.close();
    },
    close() {
      this.isOpen = false;
      // Reset state after animation
      setTimeout(() => {
        this.title = '';
        this.message = '';
        this.icon = '';
        this.iconType = 'primary';
        this.confirmText = 'Aceptar';
        this.cancelText = 'Cancelar';
        this.type = 'confirm';
        this.resolve = null;
        this.reject = null;
      }, 300);
    }
  }
});
